<app-navbar></app-navbar>
<div  id="loader-box">
    <div *ngIf="!IsLanderFounded && !waitLoader"class="text-center padding-one">
      <div  class="spinner-border spinner-loader spinner-border-sm" role="status"></div>
      <div class="loading-msg">{{TextLoader}}</div>
    </div>
    <div *ngIf="!IsLanderFounded && waitLoader" class="text-center padding-second" >
      <div class="wrapper">
        <div id="countdown-number">{{countdown}}</div>
      </div>
      <div class="loading-msg padding-three">Communicating with lenders, this shouldn’t take more than 50 seconds. Please wait.</div>
    </div>
    <div *ngIf="IsLanderFounded" class="text-center padding-one" >
      <div class="loading-msg padding-four">Congratulations! We found an eligible loan for you. Redirecting ... </div>
    </div>
  </div>
  <app-footer></app-footer>

